import React from "react";
import cn from "classnames";
import styles from "./TextBox.module.scss";
export default function TextBox(props) {
    var _a, _b, _c, _d;
    const isMultiline = (_a = props.multiline) !== null && _a !== void 0 ? _a : false;
    const isResize = (_b = props.resize) !== null && _b !== void 0 ? _b : false;
    return (React.createElement(React.Fragment, null,
        !isMultiline && (React.createElement("input", { className: cn(styles.input, props.className), type: (_c = props.type) !== null && _c !== void 0 ? _c : "text", value: props.value, onChange: (e) => props.setValue(e.target.value), required: props.required })),
        isMultiline && (React.createElement("textarea", { className: cn(styles.input, props.className), style: { resize: isResize ? "both" : "none" }, value: props.value, onChange: (e) => props.setValue(e.target.value), rows: (_d = props.rows) !== null && _d !== void 0 ? _d : 5, required: props.required }))));
}
